import { render, staticRenderFns } from "./text-editor.vue?vue&type=template&id=54bc30ae&scoped=true"
import script from "./text-editor.vue?vue&type=script&lang=ts"
export * from "./text-editor.vue?vue&type=script&lang=ts"
import style0 from "./text-editor.vue?vue&type=style&index=0&id=54bc30ae&prod&lang=postcss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54bc30ae",
  null
  
)

export default component.exports